import { render } from "./CustomBtn.vue?vue&type=template&id=1e3e867d&scoped=true&ts=true"
import script from "./CustomBtn.vue?vue&type=script&lang=ts"
export * from "./CustomBtn.vue?vue&type=script&lang=ts"

import "./CustomBtn.vue?vue&type=style&index=0&id=1e3e867d&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3e867d"]])

export default __exports__